import AutoFinetuneLanding from '../components/AutoFinetuneLanding.vue';
import FinetuneSuggestionList from '@modules/Policy/components/FinetuneSuggestionList.vue';
import FinetuneSuggestionDetail from '@modules/Policy/components/FinetuneSuggestionDetail.vue';
import { AUTO_FINETUNE_PATHS, AUTO_FINETUNE_ROUTE_NAMES } from './routes';

export default [
  {
    path: '',
    redirect: { name: AUTO_FINETUNE_ROUTE_NAMES.LANDING },
    role: ['User']
  },
  {
    path: 'landing',
    name: AUTO_FINETUNE_ROUTE_NAMES.LANDING,
    component: AutoFinetuneLanding,
    meta: {
      title: 'Auto Finetune',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: AUTO_FINETUNE_PATHS.LANDING,
          title: 'Auto Finetune'
        }
      ]
    }
  },
  {
    path: 'suggestions',
    name: AUTO_FINETUNE_ROUTE_NAMES.SUGGESTIONS,
    component: FinetuneSuggestionList,
    meta: {
      title: 'Finetune Suggestions',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: AUTO_FINETUNE_PATHS.SUGGESTIONS,
          title: 'Auto Finetune'
        },
        {
          path: AUTO_FINETUNE_PATHS.SUGGESTIONS,
          title: 'Suggestions'
        }
      ]
    }
  },
  {
    path: 'suggestions/detail',
    name: AUTO_FINETUNE_ROUTE_NAMES.SUGGESTION_DETAIL,
    component: FinetuneSuggestionDetail,
    meta: {
      title: 'Finetune Suggestion Detail',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: AUTO_FINETUNE_PATHS.SUGGESTIONS,
          title: 'Auto Finetune'
        },
        {
          path: AUTO_FINETUNE_PATHS.SUGGESTIONS,
          title: 'Suggestions'
        },
        {
          path: '',
          title: 'Detail'
        }
      ]
    }
  }
];
